import React from "react";
import "./toolTips.css"

export enum ToolTipAlign {
    left,
    right,
    center,
}

export enum ToolTipPosition {
    top,
    bottom,
    center,
}

interface IProps {
    tips: string,
    children: any,
    alignStyle?: ToolTipAlign,
    position?: ToolTipPosition,
    disable?: boolean,
}

export default function ToolTips(props: IProps) {
    const { tips, children, alignStyle = ToolTipAlign.left, position = ToolTipPosition.bottom, disable = false } = props

    let align = ""
    if (alignStyle === ToolTipAlign.left) {
        align = "left-0"
    } else if (alignStyle === ToolTipAlign.right) {
        align = "right-0"
    } else if (alignStyle === ToolTipAlign.center) {
        align = "left-1/2"
    }

    let poi = ""
    if (position === ToolTipPosition.top) {
        poi = "bottom-full mb-2"
    } else if (position === ToolTipPosition.bottom) {
        poi = "top-full mt-2"
    } else if (position === ToolTipPosition.center) {
        poi = "bottom-1/2"
    }

    let width = ""
    if (tips.length < 25) {
        width = `${alignStyle === ToolTipAlign.center ? "-ml-16" : ""} w-32`
    } else if (tips.length < 50) {
        width = `${alignStyle === ToolTipAlign.center ? "-ml-24" : ""} w-48`
    } else if (tips.length < 75) {
        width = `${alignStyle === ToolTipAlign.center ? "-ml-32" : ""} w-64`
    } else if (tips.length < 100) {
        width = `${alignStyle === ToolTipAlign.center ? "-ml-40" : ""} w-80`
    } else {
        width = `${alignStyle === ToolTipAlign.center ? "-ml-48" : ""} w-96`
    }

    return (
        <div className={"tooltip relative"}>
            <div className={`${width} min-w-full flex flex-row justify-center bg-black bg-opacity-80 rounded-lg px-3 py-2 z-50 ${align} ${poi} absolute invisible ${disable ? "" : "tooltip-item"}`}>
                <span className={"text-sm text-white text-center font-normal"}>{tips}</span>
            </div>
            {children}
        </div>
    )
}
